export default __webpack_public_path__ + "static/media/v.b2fac8b7.svg";